module.exports = __webpack_public_path__ + "static/media/Welcome-Image.2ebf1b38.jpg";